<template>
  <div>
    <vx-card>
      <h4 class="mb-4">แก้ไขรหัสผ่าน UFA</h4>
      <div class="vx-row">
        <div class="vx-col md:w-5/5 w-full mt-2 mx-5">
          <vx-input-group class="mb-base">
            <label for="ีusername"> รหัสผ่าน UFA เดิม</label>
            <vs-input
              disabled
              class="mt-2"
              readonly
              v-model="passwordUfa"
              type="text"
              name="password"
            />
            <template slot="append"> </template>
          </vx-input-group>
          <vx-input-group class="mb-base">
            <label for="ีusername"> รหัสผ่าน UFA ใหม่ </label>
            <vs-input
              class="mt-2"
              v-model.trim="newPasswordUfa"
              type="text"
              name="username"
            />
            <template slot="append"> </template>
          </vx-input-group>

          <vs-input-group class="mb-base">
            <vs-button
              class="mr-5"
              style="float: right"
              v-on:click="submit"
              color="success"
              type="filled"
            >
              บันทึก
            </vs-button>
          </vs-input-group>
        </div>
      </div>
      <div class="vx-row"></div>
    </vx-card>
  </div>
</template>

<script>
import axios from '../../../axios'


export default {
  data () {
    return {
      passwordUfa: '',
      newPasswordUfa: ''
    }
  },
  async mounted () {
    await this.getPasswordUfa()
  },
  methods: {
    async getPasswordUfa () {
      await axios
        .get(`/member/${this.$route.params.username}`)
        .then(response => (this.passwordUfa = response.data.member_ufa_password))
    },
    async submit () {
      await axios
        .post('member/updatePasswordUfa', {
          username: this.$route.params.username,
          password : this.newPasswordUfa
        }).then(response => (this.response = response.data))
      console.log(this.response)
      if (this.response.status === false) {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'ทำรายการไม่สำเร็จ',
          text: this.response.info
        })
      } else {
        this.$vs.notify({
          time: 8000,
          color: 'success',
          position: 'top-right',
          icon: 'check_box',
          title: 'ทำรายการสำเร็จ',
          text: this.response.info
        })
        await this.getPasswordUfa()
        this.newPasswordUfa = ''
      }
    }
  }
}
</script>

<style></style>
